import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowTriangleBottom"><Path d="M19.5 4.5H4.5L12 19.5L19.5 4.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleBottom;
